// src/composables/usePageScroll.ts

import { onMounted, onUnmounted, ref, Ref } from 'vue';

/**
 * 监听页面或指定元素滚动事件的 hook
 * @param {Ref<HTMLElement | null> | HTMLElement | null} target - 可选的目标元素，如果不传则监听window滚动
 * @returns {Object} 对象，包含当前滚动的距离
 */
export function usePageScroll(target?: Ref<HTMLElement | null> | HTMLElement | null) {
    const scrollDistance = ref({ x: 0, y: 0 });

    function handleScroll(e: Event) {
        let currentX = 0;
        let currentY = 0;

        // 判断滚动目标
        if (target) {
            // 如果target是ref类型
            const element = (target as Ref<HTMLElement | null>)?.value || target as HTMLElement;
            if (element && element.scrollLeft !== undefined && element.scrollTop !== undefined) {
                currentX = element.scrollLeft;
                currentY = element.scrollTop;
            }
        } else {
            // 默认监听window滚动
            currentX = window.scrollX;
            currentY = window.scrollY;
        }

        scrollDistance.value = {
            x: currentX,
            y: currentY
        };
    }

    onMounted(() => {
        if (target) {
            // 监听指定元素的滚动
            const element = (target as Ref<HTMLElement | null>)?.value || target as HTMLElement;
            if (element) {
                element.addEventListener('scroll', handleScroll);
            }
        } else {
            // 监听window滚动
            window.addEventListener('scroll', handleScroll);
        }
    });

    onUnmounted(() => {
        if (target) {
            // 移除指定元素的滚动监听
            const element = (target as Ref<HTMLElement | null>)?.value || target as HTMLElement;
            if (element) {
                element.removeEventListener('scroll', handleScroll);
            }
        } else {
            // 移除window滚动监听
            window.removeEventListener('scroll', handleScroll);
        }
    });

    return scrollDistance;
}